export const dataLayerPush = (object: Object) => {
  return window.dataLayer.push(object);
};

window.dataLayerPush = dataLayerPush;
